export const LangCodes: Record<string, string> = {
    en: "eng", // English
    fr: "fre", // French
    es: "spa", // Spanish
    de: "deu", // German
    zh: "zho", // Chinese
    ru: "rus", // Russian
    ja: "jpn", // Japanese
    it: "ita", // Italian
    ko: "kor", // Korean
    ar: "ara", // Arabic
    pt: "por", // Portuguese
    nl: "nld", // Dutch
    sv: "swe", // Swedish
    no: "nor", // Norwegian
    fi: "fin", // Finnish
    da: "dan", // Danish
    pl: "pol", // Polish
    el: "ell", // Greek
    tr: "tur", // Turkish
    he: "heb", // Hebrew
    id: "ind", // Indonesian
    th: "tha", // Thai
    vi: "vie", // Vietnamese
    hi: "hin", // Hindi
    bn: "ben", // Bengali
    ta: "tam", // Tamil
    ur: "urd", // Urdu
    fa: "fas", // Persian
    cs: "ces", // Czech
    sk: "slk", // Slovak
    hu: "hun", // Hungarian
    ro: "ron", // Romanian
    bg: "bul", // Bulgarian
    uk: "ukr", // Ukrainian
    sr: "srp", // Serbian
    hr: "hrv", // Croatian
    sl: "slv", // Slovenian
};
